import { NgModule } from '@angular/core';
import { GermplasmImportComponent, GermplasmImportPopupComponent } from './germplasm-import.component';
import { BmsjHipsterSharedModule } from '../../shared';
import { GermplasmImportBasicDetailsComponent } from './germplasm-import-basic-details.component';
import { RouterModule } from '@angular/router';
import { GermplasmImportInventoryComponent } from './germplasm-import-inventory.component';
import { GermplasmImportReviewComponent, NameColumnPipePipe } from './germplasm-import-review.component';
import { GermplasmImportContext } from './germplasm-import.context';
import { GermplasmImportMatchesComponent } from './germplasm-import-matches.component';
import { TruncateSpanComponent } from '../../shared/util/span-truncate/truncate-span.component';
import { HelpLinkComponent } from '../../shared/help-link/help-link.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule,
        TruncateSpanComponent,
        HelpLinkComponent
    ],
    declarations: [
        GermplasmImportComponent,
        GermplasmImportPopupComponent,
        GermplasmImportBasicDetailsComponent,
        GermplasmImportInventoryComponent,
        GermplasmImportMatchesComponent,
        GermplasmImportReviewComponent,
        NameColumnPipePipe
    ],
    providers: [
        GermplasmImportContext
    ]
})
export class GermplasmImportModule {

}
